export default defineNuxtPlugin(() => {
  const delay = Number(useRuntimeConfig().public.REFRESH_PAGE_DELAY_IN_HOUR) * 3600 * 1000;
  let hiddenDate = null;
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "hidden") {
      hiddenDate = Date.now();
    }
    if (document.visibilityState === "visible" && hiddenDate) {
      const diff = Date.now() - hiddenDate;
      hiddenDate = null;
      if (diff > delay) {
        window.location.reload(true);
      }
    }
  });
});
